import axios from '../axios';
import { checkResponse, getProjectId } from '../utils';
import { apiV1 } from '../utils/constant';

/**
 * @function getNotice
 * @desc 获取通知公告
 */
function getNotice(page) {
  return axios.get(`${apiV1}/projects/${getProjectId()}/download/announcement/page?page=${page}&per=10`).then(checkResponse);
}

/**
 * @function getNoticeDetail
 * @desc 获取通知公告详情
 */
function getNoticeDetail(announcementId) {
  return axios.get(`${apiV1}/projects/${getProjectId()}/download/announcement/main/${announcementId}`).then(checkResponse);
}

/**
 * @function addNotice
 * @desc 添加通知公告
 */
function addNotice(data,level) {
  return axios.post(`${apiV1}/projects/${getProjectId()}/download/announcement/main${level? `?level=${level}`: ''}`, data).then(checkResponse);
}

/**
 * @function addNoticeComment
 * @desc 添加通知公告评论
 */
function addNoticeComment(data) {
  return axios.post(`${apiV1}/projects/${getProjectId()}/download/announcement/child`, data).then(checkResponse);
}

/**
 * @function addNoticeAtt
 * @desc 添加通知公告附件
 */
function addNoticeAtt(data) {
  return axios.post(`${apiV1}/projects/${getProjectId()}/download/announcement/att`, data).then(checkResponse);
}
/**
 * @function delNotice
 * @desc 删除通知公告
 */
function delNotice(id) {
  return axios.delete(`${apiV1}/projects/${getProjectId()}/download/announcement/${id}`).then(checkResponse);
}


export {
  getNotice,
  getNoticeDetail,
  addNotice,
  addNoticeComment,
  addNoticeAtt,
  delNotice
}
